import type { ReservationInterface } from '@/components/common/tables/tables.types';
import useOrganizationName from '@/hooks/useOrganizationName';
import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

type UseGetReservationsByServiceIdProps = {
  serviceId: string | null;
  startDate?: Date;
  endDate?: Date;
  enabled?: boolean;
};

const useGetReservationsByServiceId = <TResult,>({
  serviceId,
  startDate,
  endDate,
  enabled = true
}: UseGetReservationsByServiceIdProps) => {
  const organizationName = useOrganizationName();

  return useQuery<ReservationInterface[]>({
    queryKey: ['reservations', serviceId, startDate, endDate, organizationName],
    queryFn: async () => {
      if (!serviceId) {
        return [];
      }

      const startOfDay = startDate && new Date(startDate).setHours(0, 0, 0, 0);
      const endOfDay = endDate && new Date(endDate).setHours(23, 59, 59, 999);

      const URI =
        startDate && endDate
          ? `showConsumerConcurrent=true&filter.sale.service.id=string.eq.${serviceId}&filter.startTime=number.between.${startOfDay},${endOfDay}&sortBy=sale.saleConsumers.consumer.firstName&sortDirection=ASC`
          : `showConsumerConcurrent=true&filter.sale.service.id=string.eq.${serviceId}&sortBy=sale.saleConsumers.consumer.firstName&sortDirection=ASC`;

      const response = await api.reservations.getReservationByServiceId(URI);
      return response;
    },
    refetchInterval: 100 * 5000,
    refetchOnReconnect: true,
    enabled
  });
};

export default useGetReservationsByServiceId;
